import { render, staticRenderFns } from "./orderCreate.vue?vue&type=template&id=64b94a25&scoped=true&"
import script from "./orderCreate.vue?vue&type=script&lang=js&"
export * from "./orderCreate.vue?vue&type=script&lang=js&"
import style0 from "./orderCreate.vue?vue&type=style&index=0&id=64b94a25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b94a25",
  null
  
)

export default component.exports